(() => {
    const imagesAttributes = document.getElementsByClassName('product-gallery__media');
    let actualImage = null;
    let actualAttribute = '';
    var principalImageGallery = '';
    const containerSecondaryImage = document.getElementsByClassName('product-secondary-image')[0];
    var lens = '';
    let ratio = 3;
    let window_width = null;

    let style_attributes = `--zoom-x: 0%; --zoom-y: 0%; --display-secondary: none; --opacity-secondary: 0`;
    containerSecondaryImage.setAttribute('style', style_attributes);

    const totalVariants = document.getElementById('total_variants');

    widthActual();
    getZoom();

    function getZoom() {
        getActualImage().then((img) => {
            let imgActual = img.getElementsByClassName('rounded')[0];
            let image_src = imgActual.getAttribute('src');
            style_attributes = `${style_attributes}--url-secondary: url(${image_src});`;
            containerSecondaryImage.setAttribute('style', style_attributes);
        });
    };

    if (parseInt(totalVariants.value) == 1) {
        principalImageGallery = document.getElementsByClassName('product-gallery__ar-wrapper')[0];
        lens = document.getElementById('lens');

        zoomPrincipalImageGallery(principalImageGallery);


    } else {
        setTimeout(() => {
            getElementsProductGallery().then((element) => {
                principalImageGallery = element.getElementsByClassName('product-gallery__ar-wrapper')[0];
                zoomPrincipalImageGallery(principalImageGallery);
            })
        }, 600);
    }

    function zoomPrincipalImageGallery(principalImageGallery) {
        principalImageGallery.addEventListener('mouseenter', (event) => {
            getZoom();

            if (window_width > 1150) {
                if(lens) {
                    lens.style.setProperty('--display-lens', 'block');
                    lens.style.setProperty('--opacity-lens', '1');
                }
            } else {
                if(lens) {
                    lens.style.setProperty('--display-lens', 'none');
                    lens.style.setProperty('--opacity-lens', '0');
                }
            }
        });

        principalImageGallery.addEventListener('mousemove', (event) => {
            if (window_width > 1150) {
                containerSecondaryImage.style.setProperty('--display-secondary', 'block');
                containerSecondaryImage.style.setProperty('--opacity-secondary', '1');
                containerSecondaryImage.style.setProperty('transition', 'all 0ms linear');
                lens.style.setProperty('--display-lens', 'block');
                lens.style.setProperty('--opacity-lens', '1');

                let pointer = {
                    x: (event.offsetX * 100) / principalImageGallery.offsetWidth,
                    y: (event.offsetY * 100) / principalImageGallery.offsetHeight
                }

                containerSecondaryImage.style.setProperty('--zoom-x', pointer.x + '%');
                containerSecondaryImage.style.setProperty('--zoom-y', pointer.y + '%');

                let pos = getCursor();

                let positionLeft = pos.x - (lens.offsetWidth / 2)
                let positionTop = pos.y - (lens.offsetHeight / 2)

                if (positionLeft < 0) {
                    positionLeft = 0
                }

                if (positionTop < 0) {
                    positionTop = 0
                }

                if (positionLeft > principalImageGallery.width - lens.offsetWidth / 3) {
                    positionLeft = principalImageGallery.width - lens.offsetWidth / 3
                }

                if (positionTop > principalImageGallery.height - lens.offsetHeight / 3) {
                    positionTop = principalImageGallery.height - lens.offsetHeight / 3
                }

                lens.style.left = positionLeft + 'px';
                lens.style.top = positionTop + 'px';

                lens.style.backgroundPosition = "-" + (pos.x * ratio) + 'px -' + (pos.y * ratio) + 'px'
            }
        });

        principalImageGallery.addEventListener('mouseout', () => {
            if (window_width > 1150) {
                containerSecondaryImage.style.setProperty('--display-secondary', 'none');
                containerSecondaryImage.style.setProperty('--opacity-secondary', '0');
                containerSecondaryImage.style.setProperty('transition', 'all 0ms linear');
                lens.style.setProperty('--display-lens', 'none');
                lens.style.setProperty('--opacity-lens', '0');
            }
        });
    }


    function getCursor() {
        let e = window.event
        let bounds = principalImageGallery.getBoundingClientRect();

        let x = e.pageX - bounds.left
        let y = e.pageY - bounds.top
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;

        return { 'x': x, 'y': y }
    }

    function getActualImage() {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                imagesAttributes[i].classList.add("clase-agregada");

                if (imagesAttributes[i].classList.contains('is-selected')) {
                    actualImage = imagesAttributes[i];
                    resolve(actualImage);
                }
            }
        });
    };

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getElementsProductGallery() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let productGalleryElements = document.getElementsByTagName('product-gallery');
                let lensElements = document.getElementsByClassName('lens');
                let arrLens = []

                for (let i = 0; i < lensElements.length; i++) {
                    arrLens.push(lensElements[i]);

                    if (i == 1) {
                        lens = arrLens[1];
                    }
                }
                let style_lens = `--display-lens: none; --opacity-lens: 0`;

                if(lens){
                    lens.setAttribute('style', style_lens);
                }

                for (let i = 0; i < productGalleryElements.length; i++) {
                    const element = productGalleryElements[i];

                    if (element.classList.contains('starapps')) {
                        resolve(element);
                    }
                }
            }, 750);
        });
    }

    window.addEventListener("DOMContentLoaded", (ev) => {
        if (window_width < 1150) {
            if(lens) {
                lens.style.setProperty('--display-lens', 'none');
                lens.style.setProperty('--opacity-lens', '0');
            }
        }

        window.addEventListener("resize", (event) => {
            widthActual();

            if (window_width < 1150) {
                lens.style.setProperty('--display-lens', 'none');
                lens.style.setProperty('--opacity-lens', '0');
            }
        });

    });
})()